import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getPaginationActions } from '~/shared/helpers/redux-helpers';
import { initialPageInfo } from '~/shared/store/slices/lessons/lessons-slice';
import type { UserType } from '~/types';

type LessonTemplatesType = {
  dialogsPagination: {
    items: Record<string, unknown>[];
    isLoading: boolean;
    pageInfo: Record<string, unknown>;
  };
};

const initialState: LessonTemplatesType = {
  dialogsPagination: {
    items: [],
    isLoading: false,
    pageInfo: initialPageInfo,
  },
};

export const dialogsSlice = createSlice({
  name: 'dialogs',
  initialState,
  reducers: {
    setDialogsPagination: (state, action: PayloadAction<UserType>) => {
      state.dialogsPagination = action.payload;
    },
    ...getPaginationActions('dialogsPagination'),
  },
});

export const { setDialogsPaginationLoading, appendDialogsPagination, setDialogsPagination } = dialogsSlice.actions;
